import styled from "styled-components";

export default styled.div`
    .titleRow h1 {
        margin-bottom: 0;
    }

    .details {
        display: flex;
        flex-direction: row;
        margin: 0 -5px 20px -5px;

        .detail {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin: 0 5px;

            p {
                color: black;
                font-size: 14px;
            }

            svg {
                color: #999999;
                font-size: 10px;
                margin-right: 4px;
                margin-bottom: 2px;
            }
        }
    }
`;
